export default "__VITE_ASSET__BqsXBVuw__"